import { Outlet } from 'react-router-dom';
import logo from "../images/branding/logo-brown-text-white-inline.svg";
import { ExceptionMessage } from "../components"; // Assuming ExceptionMessage is here
import { useBookingTracking, useUrlParams } from "../hooks";

export function PublicPageLayout() {
  // Child routes share their params with the layout, so this covers the
  // booking, confirmation and invoice pages. The cancel page has no code
  // in its URL and loads tracking itself.
  useBookingTracking(useUrlParams("locationCode"));

  return (
    <div id="main-wrapper" className="position-fixed d-flex flex-column w-100 h-100">
      <div id="main-topbar" className="position-relative flex-shrink-1">
        <nav className="navbar navbar-expand-lg bg-primary py-2 px-3 justify-content-center">
          <span className={`py-2 lh-5 fs-3 me-0 ms-3`}>
            <img className="d-block" src={logo} width={176} alt="Ameena logo" />
          </span>
        </nav>
      </div>
      <div className="position-relative flex-grow-1 overflow-auto booking-container-bg ">
        <div className="container py-4">
          {/* Show the error message */}
          <div className="d-flex justify-content-center">
            <ExceptionMessage />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default PublicPageLayout;
